export const getCandidates = (state) => {
  return state.candidates.candidates || [];
};

export const getCandidatesJobs = (state) => {
  return state.candidates.candidateJobs || [];
};


